<template>
  <v-container class="text-center d-flex flex-column justify-center align-center">
    <BaseTitle class="mt-2">Confirmation effectuée</BaseTitle>
    <BaseParagraph class="mt-10 mx-6">
      <strong>Votre e-mail a bien été confirmé</strong>.
    </BaseParagraph>
    <v-img class="mt-16 mb-3 mx-12" width="60%" src="@/assets/done.svg" />
    <BaseButton outlined to="/">Revenir à l'accueil</BaseButton>
  </v-container>
</template>

<script>
import BaseParagraph from '@/components/BaseParagraph.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'SignUpSuccess',
  components: {
    BaseParagraph,
    BaseButton,
    BaseTitle,
  },
};
</script>
